import { useApi } from "@core/api";
import { useCurrentUser } from "@core/hooks/useCurrentUser";
import { useQuery } from "@tanstack/react-query";

/** Gold for private clients, grey for every other signed-in account. Hidden until that status is known. */
export function HeaderAccountKindPill() {
  const api = useApi();
  const { user } = useCurrentUser();
  const { data, isFetched } = useQuery({
    queryKey: ["private-client", user?.Id],
    queryFn: () => api.GetSPGPrivateClient(),
    enabled: !!user?.Id,
    staleTime: 60_000,
  });

  if (!user?.Id || !isFetched) return null;

  const isPrivate = data?.IsPrivateClient === true;
  return (
    <span
      className={isPrivate ? "header-account-pill header-account-pill-private" : "header-account-pill header-account-pill-customer"}
      data-testid="header-account-kind"
    >
      {isPrivate ? "Private Client" : "Customer"}
    </span>
  );
}
